export const ROUTE_DOMAIN_PROD = "www.snapgene.com";
export const ROUTE_HOME = "/";
export const ROUTE_PLASMIDS = "/plasmids";
export const ROUTE_PLASMID_FILES = `${ROUTE_PLASMIDS}/sequences`;
export const ROUTE_SNAPGENE_VIEWER = "/snapgene-viewer";
export const ROUTE_FREE_TRIAL = "/free-trial";
export const ROUTE_CONTACT_US = "/contact";
export const ALIAS_BASIC_CLONING_VECTORS = "basic_cloning_vectors";
export const ALIAS_FLUORESCENT_PROTEIN_GENES_AND_PLASMIDS =
	"fluorescent_protein_genes_and_plasmids";
export const ALIAS_PET_AND_DUET_VECTORS_NOVAGEN = "pet_and_duet_vectors_(novagen)";
export const ALIAS_PET_28A_PLUS = "pET-28a(%2B)";
export const ALIAS_PUC19 = "pUC19";
export const ALIAS_PBR322 = "pBR322";
export const ALIAS_PEGFP_N1 = "pEGFP-N1";
